import React from "react";
import { Badge } from "reactstrap";

interface StatusBadgeProps {
    status: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
    const getColor = () => {
        switch (status) {
            case "Active":
                return "success";
            case "Inactive":
                return "danger";
            case "Pending":
                return "warning";
            case "Approved":
                return "success";
            case "Rejected":
                return "danger";
            case "Deleted":
                return "danger";
            case "Completed":
                return "success";
        }
    };

    const getText = () => {
        switch (status) {
            case "Active":
                return "Active";
            case "Inactive":
                return "InActive";
            case "Pending":
                return "Pending";
            case "Approved":
                return "Approved";
            case "Rejected":
                return "Rejected";
            case "Deleted":
                return "Deleted";
            case "Completed":
                return "Completed";
        }
    };

    return (
        <Badge
            color={getColor()}
            className="py-sm-2 px-3 "
            style={{
                backgroundColor: getComputedStyle(document.documentElement)
                    .getPropertyValue(`--bs-${getColor()}`)
                    .trim()
                    .replace(")", `, 0.5)`)
                    .replace("rgb", "rgba"),
                color: "#fff",
                borderRadius: 15,
                width: "80px",
                height: "30px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <div style={{ fontSize: 12 }}>{getText()}</div>
        </Badge>
    );
};

export default StatusBadge;
